module.exports = {
  show_all_news: 'Show all news',
  news: 'News',
  all_news: 'All news',
}
